import React, { useState } from 'react';
import axios from 'axios';
import swal from 'sweetalert';
import { baseUrl } from '../../../../baseUrl';
import style from "../CloneExamModal.module.css"
import ContentCopyTwoToneIcon from '@mui/icons-material/ContentCopyTwoTone';
import api from '../../../../api';

// Modal component
const CopyQuestionsModal = ({ isOpen, closeModal, questionIds }) => {
  const [targetExamID, setTargetExamID] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (questionIds.length < 1) {
      swal('Error', 'Please select at least one question to clone', 'error')
      return;
    }

    if (!targetExamID) {
      swal('Error', 'Please provide target exam ID!', 'error');
      return;
    }

    setLoading(true);

    try {
      // Send POST request to clone questions
      const response = await api.post(`${baseUrl}/question/selected/copy`, {
        targetExamID, questionIds
      });

      swal('Success', response.data.message, 'success');
      closeModal(); // Close modal on success
    } catch (error) {
      swal('Error', error.response?.data?.message || 'An error occurred', 'error');
    } finally {
      setLoading(false);
    }
  };

  if (!isOpen) return null;

  return (
    <div className={`${style.modal}`} style={modalStyles}>
      <div className={`modal-content ${style.modalContent}`}>
        <span className={`${style.close}`} onClick={closeModal}>&times;</span>
        <h4>Copy Selected Questions to Another Exam</h4>
        <form onSubmit={handleSubmit}>
          <div>
            <label htmlFor="targetExamID">Target Exam ID:</label>
            <input
              className='ml-2'
              type="text"
              id="targetExamID"
              value={targetExamID}
              onChange={(e) => setTargetExamID(e.target.value)}
              required
            />
          </div>
          <div>
            <button className={`${style.cloneButton}`} type="submit" disabled={loading}>
              {loading ? <img width='25px' src='\assets\images\load-time.gif' alt='loading' /> : <ContentCopyTwoToneIcon />}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

const modalStyles = {
  position: 'fixed',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: '100%',
  // maxWidth: '700px',
  height: '100%',
  backgroundColor: 'rgba(0, 0, 0, 0.7)', // Semi-transparent dark background
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  zIndex: 1000, // Ensures the modal is above other content
  backdropFilter: 'blur(5px)', // Adds the blur effect behind the modal
};



export default CopyQuestionsModal;
